import { Link } from "react-router-dom";
import fcLogoWhite from "@/assets/fc-logo-white.png";

const Footer = () => {
  return (
    <footer className="bg-primary py-10 md:py-16">
      <div className="container mx-auto px-6 lg:px-8">
        <div className="grid grid-cols-2 md:grid-cols-5 gap-y-8 gap-x-6 md:gap-8">
          {/* Brand */}
          <div className="col-span-2 md:col-span-1">
            <Link to="/" className="inline-block mb-2 md:mb-4">
              <img src={fcLogoWhite} alt="Focus Casting" className="h-8 object-contain" />
            </Link>
            <p className="text-primary-foreground/60 text-sm max-w-[15rem]">
              Cast talent from multiple agencies in one place. Free to browse, free to request.
            </p>
          </div>

          {/* For Clients */}
          <div>
            <h4 className="font-body font-semibold text-primary-foreground mb-4">
              For Clients
            </h4>
            <ul className="space-y-3">
              <li>
                <Link to="/browse" className="text-primary-foreground/70 hover:text-primary-foreground text-sm transition-colors">
                  Browse Talent
                </Link>
              </li>
              <li>
                <Link to="/about" className="text-primary-foreground/70 hover:text-primary-foreground text-sm transition-colors">
                  How It Works
                </Link>
              </li>
              <li>
                <Link to="/auth?mode=signup&persona=client" className="text-primary-foreground/70 hover:text-primary-foreground text-sm transition-colors">
                  Create Free Account
                </Link>
              </li>
            </ul>
          </div>

          {/* Guides */}
          <div>
            <h4 className="font-body font-semibold text-primary-foreground mb-4">
              Guides
            </h4>
            <ul className="space-y-3">
              <li>
                <Link to="/casting-guide" className="text-primary-foreground/70 hover:text-primary-foreground text-sm transition-colors">
                  Casting Guide
                </Link>
              </li>
              <li>
                <Link to="/guide/packages" className="text-primary-foreground/70 hover:text-primary-foreground text-sm transition-colors">
                  Packages
                </Link>
              </li>
              <li>
                <Link to="/guide/bookings" className="text-primary-foreground/70 hover:text-primary-foreground text-sm transition-colors">
                  Booking Requests
                </Link>
              </li>
              <li>
                <Link to="/guide/fittings" className="text-primary-foreground/70 hover:text-primary-foreground text-sm transition-colors">
                  Fittings
                </Link>
              </li>
              <li>
                <Link to="/usage-basics" className="text-primary-foreground/70 hover:text-primary-foreground text-sm transition-colors">
                  Usage Rights Basics
                </Link>
              </li>
            </ul>
          </div>

          {/* For Agencies */}
          <div>
            <h4 className="font-body font-semibold text-primary-foreground mb-4">
              For Agencies
            </h4>
            <ul className="space-y-3">
              <li>
                <Link to="/agency/signup" className="text-primary-foreground/70 hover:text-primary-foreground text-sm transition-colors">
                  List Your Agency
                </Link>
              </li>
              <li>
                <Link to="/for-agencies#how-it-works" className="text-primary-foreground/70 hover:text-primary-foreground text-sm transition-colors">
                  How It Works
                </Link>
              </li>
              <li>
                <Link to="/request-agency" className="text-primary-foreground/70 hover:text-primary-foreground text-sm transition-colors">
                  Request an Agency
                </Link>
              </li>
            </ul>
          </div>

          {/* Company */}
          <div>
            <h4 className="font-body font-semibold text-primary-foreground mb-4">
              Company
            </h4>
            <ul className="space-y-3">
              <li>
                <Link to="/contact" className="text-primary-foreground/70 hover:text-primary-foreground text-sm transition-colors">
                  Contact
                </Link>
              </li>
              <li>
                <Link to="/privacy" className="text-primary-foreground/70 hover:text-primary-foreground text-sm transition-colors">
                  Privacy Policy
                </Link>
              </li>
              <li>
                <Link to="/terms" className="text-primary-foreground/70 hover:text-primary-foreground text-sm transition-colors">
                  Terms of Service
                </Link>
              </li>
            </ul>
          </div>
        </div>

        {/* Bottom */}
        <div className="mt-10 md:mt-12 pt-6 md:pt-8 border-t border-primary-foreground/20 space-y-2">
          <p className="text-center text-primary-foreground/60 text-sm">
            Focus Casting is operated by Focus Collective, LLC.
          </p>
          <p className="text-center text-primary-foreground/50 text-sm">
            © {new Date().getFullYear()} Focus Collective, LLC. All rights reserved.
          </p>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
